<template>
  <div class="editReportListPage">
    <div class="mainContent">
      <!-- 左边栏目 -->
      <div class="leftContentWrap">
        <div class="cateTabs">
          <Tabs tabPosition="top" :activeKey="defaultListKey"  @change="changCheckCate">
            <TabPane v-if="this.roles.includes('ROLE_ROOT') || this.roles.includes('ROLE_AFTER_DEAL_REPORT')" key="1" tab="运算中">
              <leftArticle
                ref="tab"
                v-if="+defaultListKey === 1"
                :dataSource="operateList"
                :activeId="activeId"
                :totalCount="totalCount"
                :pageNumber="pageNo"
                :writeDoctorList="searchOption.writeDoctorList"
                :diagnosisList="searchOption.diagnosisList"
                :deviceList="searchOption.deviceList"
                :checkHospitalList="searchOption.checkHospitalList"
                @selectItemData="selectItemData"
                @searchReportData="searchReportData"
                @pageData="pageData"></leftArticle>
            </TabPane>
            <TabPane v-if="this.roles.includes('ROLE_ROOT') || this.roles.includes('ROLE_AFTER_DEAL_REPORT') || this.roles.includes('ROLE_AUDIT_REPORT') || this.roles.includes('ROLE_WRITE_REPORT')" key="2" tab="待领取">
              <leftArticle
                ref="tab"
                v-if="+defaultListKey === 2"
                :dataSource="waitingList"
                :activeId="activeId"
                :totalCount="totalCount"
                :pageNumber="pageNo"
                :writeDoctorList="searchOption.writeDoctorList"
                :diagnosisList="searchOption.diagnosisList"
                :deviceList="searchOption.deviceList"
                :checkHospitalList="searchOption.checkHospitalList"
                @selectItemData="selectItemData"
                @searchReportData="searchReportData"
                @pageData="pageData"></leftArticle>
            </TabPane>
            <TabPane v-if="this.roles.includes('ROLE_ROOT') || this.roles.includes('ROLE_AFTER_DEAL_REPORT') || this.roles.includes('ROLE_AUDIT_REPORT') || this.roles.includes('ROLE_WRITE_REPORT')" key="3" tab="处理中">
              <leftArticle
                ref="tab"
                v-if="+defaultListKey === 3"
                :dataSource="handerList"
                :activeId="activeId"
                :totalCount="totalCount"
                :pageNumber="pageNo"
                :writeDoctorList="searchOption.writeDoctorList"
                :diagnosisList="searchOption.diagnosisList"
                :deviceList="searchOption.deviceList"
                :checkHospitalList="searchOption.checkHospitalList"
                @selectItemData="selectItemData"
                @searchReportData="searchReportData"
                @pageData="pageData"></leftArticle>
            </TabPane>
            <TabPane v-if="this.roles.includes('ROLE_ROOT') || this.roles.includes('ROLE_AFTER_DEAL_REPORT') || this.roles.includes('ROLE_AUDIT_REPORT') || this.roles.includes('ROLE_WRITE_REPORT')" key="4" tab="我的报告">
              <leftArticle
                ref="tab"
                v-if="+defaultListKey === 4"
                :dataSource="myReportList"
                :activeId="activeId"
                :totalCount="totalCount"
                :pageNumber="pageNo"
                :writeDoctorList="searchOption.writeDoctorList"
                :diagnosisList="searchOption.diagnosisList"
                :deviceList="searchOption.deviceList"
                :checkHospitalList="searchOption.checkHospitalList"
                @selectItemData="selectItemData"
                @searchReportData="searchReportData"
                @pageData="pageData"></leftArticle>
            </TabPane>
            <TabPane v-if="this.roles.includes('ROLE_ROOT') || this.roles.includes('ROLE_AFTER_DEAL_REPORT') || this.roles.includes('ROLE_AUDIT_REPORT') || this.roles.includes('ROLE_WRITE_REPORT')" key="5" tab="历史报告">
              <leftArticle
                ref="tab"
                v-if="+defaultListKey === 5"
                :dataSource="hisList"
                :activeId="activeId"
                :totalCount="totalCount"
                :pageNumber="pageNo"
                :writeDoctorList="searchOption.writeDoctorList"
                :diagnosisList="searchOption.diagnosisList"
                :deviceList="searchOption.deviceList"
                :checkHospitalList="searchOption.checkHospitalList"
                @selectItemData="selectItemData"
                @searchReportData="searchReportData"
                @pageData="pageData"></leftArticle>
            </TabPane>
            <TabPane v-if="this.roles.includes('ROLE_ROOT') || this.roles.includes('ROLE_SENIOR_DOCTOR')" key="6" tab="全部报告">
              <leftArticle
                ref="tab"
                v-if="+defaultListKey === 6"
                :dataSource="allList"
                :activeId="activeId"
                :totalCount="totalCount"
                :pageNumber="pageNo"
                :writeDoctorList="searchOption.writeDoctorList"
                :diagnosisList="searchOption.diagnosisList"
                :deviceList="searchOption.deviceList"
                :checkHospitalList="searchOption.checkHospitalList"
                @selectItemData="selectItemData"
                @searchReportData="searchReportData"
                @pageData="pageData"></leftArticle>
            </TabPane>
            <div slot="tabBarExtraContent" class="arowWrap"></div>
          </Tabs>
        </div>
      </div>
      <!-- 右边栏目 -->
      <div class="rightContent">
        <div class="static">
          <div v-if="+defaultListKey === 1">
            <span>运算中：{{staticData && staticData.IN_PROCESSING ? staticData.IN_PROCESSING : 0}}，</span>
            <span>运算失败：{{staticData && staticData.FAIL ? staticData.FAIL : 0}}</span>
          </div>
          <div v-if="+defaultListKey === 2">
            <span>待编写：{{staticData && staticData.WAIT_WRITE ? staticData.WAIT_WRITE : 0}}，</span>
            <span>待审核：{{staticData && staticData.WAIT_EXAMINE ? staticData.WAIT_EXAMINE : 0}}</span>
          </div>
          <div v-if="+defaultListKey === 3">
            <span>编写中：{{staticData && staticData.WRITING ? staticData.WRITING : 0}}，</span>
            <span>审核中：{{staticData && staticData.IN_AUDIT ? staticData.IN_AUDIT : 0}}</span>
          </div>
          <div v-if="+defaultListKey === 4">
            <span>总数：{{staticData ? staticData.total : 0}}</span>
          </div>
          <div v-if="+defaultListKey === 5">
            <span>总数：{{staticData ? staticData.total : 0}}</span>
          </div>
          <div v-if="+defaultListKey === 6">
            <span>总数：{{staticData ? staticData.total : 0}}</span>
          </div>
        </div>
        <div class="operateCard">
          <div class="top">
            <!-- 运算中 -->
            <Button
              type="primary"
              block
              v-if="
                (this.roles.includes('ROLE_AFTER_DEAL_REPORT'))
                &&
                [0, 5, 10, 20, 30].includes(selectItem.status_detail)
                &&
                [1].includes(+defaultListKey)"
                @click="handleRecalculate"
              >重新运算</Button>
            <Button
              type="primary"
              block
              v-else-if="
                operateList.length <= 0
                &&
                (this.roles.includes('ROLE_AFTER_DEAL_REPORT'))
                &&
                [1].includes(+defaultListKey)"
                @click="handleRecalculate"
              >重新运算</Button>
            <!-- 待领取 -->
            <Button
              type="primary"
              block
              v-else-if="
                (this.roles.includes('ROLE_ROOT') || this.roles.includes('ROLE_WRITE_REPORT') || this.roles.includes('ROLE_AFTER_DEAL_REPORT'))
                &&
                [1, 10].includes(selectItem.status)
                &&
                [2].includes(+defaultListKey)"
                @click="writeReport"
            >编写</Button>
            <Button
              type="primary"
              block
              v-else-if="
                (this.roles.includes('ROLE_ROOT') || this.roles.includes('ROLE_AUDIT_REPORT'))
                &&
                [20, 30].includes(selectItem.status)
                &&
                [2].includes(+defaultListKey)
              "
              @click="audit"
            >审核</Button>
            <Button
              type="primary"
              block
              v-else-if="
                waitingList.length <= 0
                &&
                (this.roles.includes('ROLE_WRITE_REPORT') || this.roles.includes('ROLE_AFTER_DEAL_REPORT'))
                &&
                [2].includes(+defaultListKey)"
                @click="writeReport"
            >编写</Button>
            <Button
              type="primary"
              block
              v-else-if="
                waitingList.length <= 0
                &&
                (this.roles.includes('ROLE_AUDIT_REPORT'))
                &&
                [2].includes(+defaultListKey)
              "
              @click="audit"
            >审核</Button>
            <!-- 处理中 -->
            <!-- 编写和审核 -->
            <Button type="primary" block v-else-if="defaultListKey == 3 && selectItem.status == 10 && selectItem.reportCategoryName =='常规报告' && role.write" @click="writeReport">编写</Button>
            <Button type="primary" block v-else-if="defaultListKey == 3 && selectItem.status == 30 && role.review" @click="audit">审核</Button>
            <Button type="primary" block v-else-if="defaultListKey == 3 && selectItem.status == 10 && selectItem.reportCategoryName !=='常规报告' && role.afterWrite" @click="writeReport">编写</Button>
            <Button
              type="primary"
              block
              v-else-if="
                handerList.length <= 0
                &&
                (role.write || (role.write && role.afterWrite))
                &&
                [3].includes(+defaultListKey)"
                @click="writeReport"
            >编写</Button>
            <Button
              type="primary"
              block
              v-else-if="
                handerList.length <= 0
                &&
                role.review
                &&
                [3].includes(+defaultListKey)
              "
              @click="audit"
            >审核</Button>
            <!-- 查看 -->
            <Button type="primary" block v-else-if="defaultListKey == 3" @click="viewsReport">查看</Button>
            <!-- 我的报告 -->
            <Button
              type="primary"
              block
              v-else-if="
                (this.roles.includes('ROLE_ROOT') || this.roles.includes('ROLE_WRITE_REPORT') || this.roles.includes('ROLE_AFTER_DEAL_REPORT'))
                &&
                [1, 10].includes(selectItem.status)
                &&
                [4].includes(+defaultListKey)"
                @click="writeReport"
            >编写</Button>
            <Button
              type="primary"
              block
              v-else-if="
                this.roles.includes('ROLE_AUDIT_REPORT')
                &&
                [20, 30].includes(selectItem.status)
                &&
                [4].includes(+defaultListKey)
              "
              @click="audit"
            >审核</Button>
            <Button
              type="primary"
              block
              v-else-if="
                (!this.roles.includes('ROLE_WRITE_REPORT') && this.roles.includes('ROLE_AUDIT_REPORT'))
                &&
                [1, 10].includes(selectItem.status)
                &&
                ![5, 10, 15].includes(selectItem.report_category)
                &&
                [4].includes(+defaultListKey)"
              @click="viewsReport('mySelf')"
            >查看</Button>
            <Button
              type="primary"
              block
              v-else-if="
                ((this.roles.includes('ROLE_WRITE_REPORT') && !this.roles.includes('ROLE_AUDIT_REPORT')))
                &&
                [20, 30].includes(selectItem.status)
                &&
                ![5, 10, 15].includes(selectItem.report_category)
                &&
                [4].includes(+defaultListKey)"
              @click="viewsReport('mySelf')"
            >查看</Button>
            <Button
              type="primary"
              block
              :disabled="[-99].includes(selectItem.status)"
              v-else-if="
                ![5, 10, 15].includes(selectItem.report_category)
                &&
                [100, -99].includes(selectItem.status)
                &&
                [4].includes(+defaultListKey)"
              @click="viewsReport('mySelf')"
            >查看</Button>
            <Button
              type="primary"
              block
              v-else-if="
                (this.roles.includes('ROLE_AFTER_DEAL_REPORT') && this.roles.includes('ROLE_AUDIT_REPORT'))
                &&
                [100, -99].includes(selectItem.status)
                &&
                [5, 10, 15].includes(selectItem.report_category)
                &&
                [4].includes(+defaultListKey)
              "
              @click="handlerViewMyReport('mySelf')"
            >查看</Button>
            <Button
              type="primary"
              block
              v-else-if="
                (this.roles.includes('ROLE_AFTER_DEAL_REPORT') && !this.roles.includes('ROLE_AUDIT_REPORT'))
                &&
                [20, 30, 100, -99].includes(selectItem.status)
                &&
                [5, 10, 15].includes(selectItem.report_category)
                &&
                [4].includes(+defaultListKey)
              "
              @click="handlerViewMyReport('mySelf')"
            >查看</Button>
            <Button
              type="primary"
              block
              v-else-if="
                (!this.roles.includes('ROLE_AFTER_DEAL_REPORT') && this.roles.includes('ROLE_AUDIT_REPORT'))
                &&
                [1, 10, 100, -99].includes(selectItem.status)
                &&
                [5, 10, 15].includes(selectItem.report_category)
                &&
                [4].includes(+defaultListKey)
              "
              @click="handlerViewMyReport('mySelf')"
            >查看</Button>
            <Button
              type="primary"
              block
              v-else-if="
                myReportList.length <= 0
                &&
                (role.write || (role.write && role.afterWrite))
                &&
                [4].includes(+defaultListKey)"
                @click="writeReport"
            >编写</Button>
            <Button
              type="primary"
              block
              v-else-if="
                myReportList.length <= 0
                &&
                role.review
                &&
                [4].includes(+defaultListKey)
              "
              @click="audit"
            >审核</Button>
            <!-- 历史报告 -->
            <Button
              type="primary"
              block
              :disabled="[-99].includes(selectItem.status)"
              v-else-if="
                [100, -99].includes(selectItem.status)
                &&
                [5].includes(+defaultListKey)"
              @click="viewsReport"
            >查看</Button>
            <Button
              type="primary"
              block
              v-else-if="
                hisList.length <= 0
                &&
                [5].includes(+defaultListKey)"
              @click="viewsReport"
            >查看</Button>
            <!-- 全部报告 -->
            <Button
              type="primary"
              block
              v-else-if="
                [1].includes(selectItem.report_category)
                &&
                [20, 100, -99].includes(selectItem.status)
                &&
                [6].includes(+defaultListKey)"
              @click="viewsReport('all')"
            >查看</Button>
            <Button
              type="primary"
              block
              :disabled="[1, 10, 30].includes(selectItem.status)"
              v-else-if="
                [1].includes(selectItem.report_category)
                &&
                [1, 10, 30].includes(selectItem.status)
                &&
                [6].includes(+defaultListKey)"
              @click="viewsReport('all')"
            >查看</Button>
            <Button
              type="primary"
              block
              v-else-if="
                [5, 10, 15].includes(selectItem.report_category)
                &&
                [20, 100].includes(selectItem.status)
                &&
                [6].includes(+defaultListKey)"
              @click="viewsAfterReport('all')"
            >查看</Button>
            <Button
              type="primary"
              block
              :disabled="[1, 10, 30, -99].includes(selectItem.status)"
              v-else-if="
                [5, 10, 15].includes(selectItem.report_category)
                &&
                [1, 10, 30, -99].includes(selectItem.status)
                &&
                [6].includes(+defaultListKey)"
              @click="viewsReport('all')"
            >查看</Button>
            <Button
              type="primary"
              block
              v-else-if="
                allList.length <= 0
                &&
                [6].includes(+defaultListKey)"
              @click="viewsReport('all')"
            >查看</Button>
            <Button
              type="primary"
              block
              disabled
              v-else-if="
                [0, 5, 10, 20, 30].includes(selectItem.status_detail)
                &&
                [6].includes(+defaultListKey)"
                @click="handleRecalculate('all')"
              >查看</Button>
          </div>
          <div class="bottom">
            <Button size="large" @click="openWeasis(reportInfo)">Unimed-K</Button>
            <Button size="large" @click="openOsirix(reportInfo)">Osirix</Button>
          </div>
          <div class="bottom">
            <Button size="large" @click="openFilmView(reportInfo)">WebViewer</Button>
            <Button size="large" @click="historyReport">历史检查</Button>
          </div>
        </div>
        <div class="checkPatient">
          <div class="reportMsg">
            <p v-if="receiveReport.notImageNum
              ||
              auditReport.notImageNum
              ||
              afterReport.notImageNum"
              style="color: #f00;"
            >技师已将影像解绑，暂无影像</p>
            <p>扫描技师：{{reportInfo && reportInfo.technicianName}}</p>
            <p>当前编写医生：{{reportInfo && reportInfo.reportInfo && reportInfo.reportInfo.report_write_doctor_name | changeDoctorName('write')}}</p>
            <p>当前审核医生：{{reportInfo && reportInfo.reportInfo && reportInfo.reportInfo.report_review_doctor_name | changeDoctorName('check')}}</p>
            <div v-if="selectItem.status === 1 && reportInfo.historyReports">
              <p v-for="(item, index) in reportInfo.historyReports" :key="index">{{item.report_write_doctor_name}} 最近曾编写过该患者的报告</p>
            </div>
            <div v-if="selectItem.status === 20 && reportInfo.historyReports">
              <p v-for="(item, index) in reportInfo.historyReports" :key="index">{{item.report_review_doctor_name}} 最近曾审核过该患者的报告</p>
            </div>
            <p>诊断中心：{{selectItem.hospital_medical_diagnose_center_name}}</p>
            <p>电话：{{selectItem.patient_mobile}}</p>
            <p>病史：{{reportInfo.medicalHistory}}</p>
            <p>备注：{{reportInfo.remark}}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 待编写 -->
    <Modal :width="682" :height="500" class="editReportListPageModal" v-model="receiveReport.showModal" :confirmLoading="loading.sureReceive" @ok="sureReceive">
      <slot slot="title">
        <span v-if="receiveReport.notImageNum" style="color: #f00;">{{receiveReport.title}}</span>
        <span v-else>{{receiveReport.title}}</span>
      </slot>
      <div v-if="!receiveReport.multiple">
        <p>是否确认领取该报告订单？</p>
        <p>领取后，其他医生将不能再领取</p>
        <p v-if="receiveReport.notImageNum">解绑原因：{{reportInfo && reportInfo.lastUnbindMessage}}</p>
      </div>
      <div v-if="receiveReport.multiple">
        <p>{{receiveReport.doctorName}} 48小时内曾{{receiveReport.reportStatusText}}过该患者的其他报告订单，您是否确定领取当前报告订单？</p>
        <p v-if="receiveReport.notImageNum">解绑原因：{{reportInfo && reportInfo.lastUnbindMessage}}</p>
      </div>
    </Modal>
    <!-- 后处理 -->
    <Modal :width="682" :height="500" class="editReportListPageModal" v-model="afterReport.showModal" :footer="afterReport.showFooter">
      <slot slot="title">
        <span v-if="afterReport.notImageNum" style="color: #f00;">{{afterReport.title}}</span>
        <span v-else>{{afterReport.title}}</span>
      </slot>
      <div v-if="afterReport.showHandler">
        <Row :gutter="24">
          <Col :span="10" v-if="[5].includes(+defaultListKey)">
            <Button style="margin-right: 16px;" v-if="
              [5, 20, 30].includes(afterProcessData.status_detail)
              &&
              afterProcessData.ai_process
              &&
              ![-99, 100].includes(afterProcessData.status)
              &&
              (isMyself(afterProcessData.report_write_doctor_id) || isMyself(afterProcessData.report_review_doctor_id))"
              size="large" @click="toOperation">重新运算</Button>
            <Button style="margin-right: 16px;" v-if="
              [10].includes(afterProcessData.status_detail)
              &&
              afterProcessData.ai_process
              &&
              ![-99, 100].includes(afterProcessData.status)
              &&
              (isMyself(afterProcessData.report_write_doctor_id) || isMyself(afterProcessData.report_review_doctor_id))"
              disabled size="large">运算中</Button>
            <Button v-if="
              ![-99, 100].includes(afterProcessData.status)
              &&
              (isMyself(afterProcessData.report_write_doctor_id) || isMyself(afterProcessData.report_review_doctor_id))
              "
              size="large" @click="downImage" :loading="downImageLoad">下载影像</Button>
          </Col>
          <Col :span="10" v-if="![5].includes(+defaultListKey)">
            <Button style="margin-right: 16px;" v-if="[5, 20, 30].includes(afterProcessData.status_detail) && afterProcessData.ai_process && ![-99, 100].includes(afterProcessData.status)" size="large" @click="toOperation">重新运算</Button>
            <Button style="margin-right: 16px;" v-if="[10].includes(afterProcessData.status_detail) && afterProcessData.ai_process && ![-99, 100].includes(afterProcessData.status)" disabled size="large">运算中</Button>
            <Button v-if="![-99, 100].includes(afterProcessData.status)" size="large" @click="downImage" :loading="downImageLoad">下载影像</Button>
          </Col>
          <Col :span="14" v-if="[5].includes(+defaultListKey)" style="text-align: right;">
            <Upload multiple  accept=".png,.jpg,.jpeg,.pdf,.txt,.doc,.csv,.gif,.xlsx,.excel" :showUploadList="false" :beforeUpload="beforeUpload">
              <Button v-if="![-99, 100].includes(afterProcessData.status) && (isMyself(afterProcessData.report_write_doctor_id) || isMyself(afterProcessData.report_review_doctor_id))" size="large" :loading="loading.uploadFile" :disabled="loading.uploadFile">上传报告</Button>
            </Upload>
          </Col>
          <Col :span="14" v-if="![5].includes(+defaultListKey)" style="text-align: right;">
            <Button size="large" style="margin-right:12px;" v-if="afterProcessData.status !== 100"  @click="writeAiReport">编写报告</Button>
            <Upload multiple  accept=".png,.jpg,.jpeg,.pdf,.txt,.doc,.csv,.gif,.xlsx,.excel" :beforeUpload="beforeUpload" :showUploadList="false">
              <Button v-if="![-99, 100].includes(afterProcessData.status)" :loading="loading.uploadFile" :disabled="loading.uploadFile" size="large">上传报告</Button>
            </Upload>
          </Col>

        </Row>
        <div style="display:flex;align-items:center;margin-top:8px" v-if="loading.uploadFile">
          <span>上传进度：</span>
          <div style="flex:1;"><Progress :percent="uploadReportProgress"/></div>
        </div>
        <div class="image">
          <h3 style="text-align: center;padding: 17% 0; " v-if="!imageList || imageList.length <= 0">暂无上传报告！</h3>
          <div v-else>
            <p v-for="(image, index) in imageList" :key="index">
              {{image.name}}
              <span v-if="[5].includes(+defaultListKey)">
                <!-- <a @click="viewImage(image)">预览</a> -->
                <a @click="downFile(image.url, image.name)">预览</a>
                <a v-if="
                  ![-99 ,100].includes(afterProcessData.status)
                  ||
                  (isMyself(afterProcessData.report_write_doctor_id) || isMyself(afterProcessData.report_review_doctor_id))
                  " @click="removeImage(image, index)">删除</a>
              </span>
              <span v-if="![5].includes(+defaultListKey)">
                <!-- <a @click="viewImage(image)">预览</a> -->
                <a @click="downFile(image.url, image.name)">预览</a>
                <a v-if="![-99, 100].includes(afterProcessData.status)" @click="removeImage(image, index)">删除</a>
              </span>
            </p>
          </div>
        </div>
        <div class="handlerFooter" slot="footer">
          <Row :gutter="24" v-if="[5].includes(+defaultListKey)">
            <Col :span="8">
              <Button
                size="large"
                @click="giveUp"
                v-if="
                  (this.roles.includes('ROLE_AFTER_DEAL_REPORT') && this.roles.includes('ROLE_AUDIT_REPORT'))
                  &&
                  ![6].includes(+defaultListKey)
                  &&
                  [20, 30].includes(afterProcessData.status)
                  &&
                  (isMyself(afterProcessData.report_write_doctor_id) || isMyself(afterProcessData.report_review_doctor_id))"
              >放弃</Button>
              <Button
                size="large"
                @click="giveUp"
                v-if="
                  this.roles.includes('ROLE_AFTER_DEAL_REPORT')
                  &&
                  ![6].includes(+defaultListKey)
                  &&
                  [10].includes(afterProcessData.status)
                  &&
                  (isMyself(afterProcessData.report_write_doctor_id) || isMyself(afterProcessData.report_review_doctor_id))"
              >放弃</Button>
              <Button
                size="large"
                @click="giveUp"
                v-if="
                  (!this.roles.includes('ROLE_AFTER_DEAL_REPORT') && this.roles.includes('ROLE_AUDIT_REPORT'))
                  &&
                  ![6].includes(+defaultListKey)
                  &&
                  [20, 30].includes(afterProcessData.status)
                  &&
                  (isMyself(afterProcessData.report_write_doctor_id) || isMyself(afterProcessData.report_review_doctor_id))"
              >放弃</Button>
              <!-- 后处理医生 -->
              <Button
                size="large"
                @click="goBackReport"
                v-if="
                  (this.roles.includes('ROLE_AFTER_DEAL_REPORT') && !this.roles.includes('ROLE_AUDIT_REPORT'))
                  &&
                  [5, 15].includes(afterProcessData.report_category)
                  &&
                  [20, 100].includes(afterProcessData.status)
                  &&
                  ![6].includes(+defaultListKey)
                  &&
                  (isMyself(afterProcessData.report_write_doctor_id) || isMyself(afterProcessData.report_review_doctor_id))"
              >召回</Button>
              <Button
                size="large"
                @click="goBackReport"
                v-if="
                  (this.roles.includes('ROLE_AFTER_DEAL_REPORT') && this.roles.includes('ROLE_AUDIT_REPORT'))
                  &&
                  [5, 15].includes(afterProcessData.report_category)
                  &&
                  [20, 100].includes(afterProcessData.status)
                  &&
                  ![6].includes(+defaultListKey)
                  &&
                  (isMyself(afterProcessData.report_write_doctor_id) || isMyself(afterProcessData.report_review_doctor_id))"
              >召回</Button>
              <Button
                size="large"
                @click="goBackReport"
                v-if="
                  (!this.roles.includes('ROLE_AFTER_DEAL_REPORT') && this.roles.includes('ROLE_AUDIT_REPORT'))
                  &&
                  [5, 15].includes(afterProcessData.report_category)
                  &&
                  [100].includes(afterProcessData.status)
                  &&
                  ![6].includes(+defaultListKey)
                  &&
                  (isMyself(afterProcessData.report_write_doctor_id) || isMyself(afterProcessData.report_review_doctor_id))"
              >召回</Button>
              <Button
                size="large"
                @click="goBackReport"
                v-if="
                  (this.roles.includes('ROLE_AFTER_DEAL_REPORT') && this.roles.includes('ROLE_AUDIT_REPORT'))
                  &&
                  [10].includes(afterProcessData.report_category)
                  &&
                  afterProcessData.review_required
                  &&
                  [20, 100].includes(afterProcessData.status)
                  &&
                  ![6].includes(+defaultListKey)
                  &&
                  (isMyself(afterProcessData.report_write_doctor_id) || isMyself(afterProcessData.report_review_doctor_id))"
              >召回</Button>
              <Button
                size="large"
                @click="goBackReport"
                v-if="
                  (this.roles.includes('ROLE_AFTER_DEAL_REPORT') && !this.roles.includes('ROLE_AUDIT_REPORT'))
                  &&
                  [10].includes(afterProcessData.report_category)
                  &&
                  afterProcessData.review_required
                  &&
                  [20, 100].includes(afterProcessData.status)
                  &&
                  ![6].includes(+defaultListKey)
                  &&
                  (isMyself(afterProcessData.report_write_doctor_id) || isMyself(afterProcessData.report_review_doctor_id))"
              >召回</Button>
              <Button
                size="large"
                @click="goBackReport"
                v-if="
                  (!this.roles.includes('ROLE_AFTER_DEAL_REPORT') && this.roles.includes('ROLE_AUDIT_REPORT'))
                  &&
                  [10].includes(afterProcessData.report_category)
                  &&
                  afterProcessData.review_required
                  &&
                  [100].includes(afterProcessData.status)
                  &&
                  ![6].includes(+defaultListKey)
                  &&
                  (isMyself(afterProcessData.report_write_doctor_id) || isMyself(afterProcessData.report_review_doctor_id))"
              >召回</Button>
              <!-- 高级医生 -->
              <Button
                size="large"
                @click="goBackReport"
                v-if="
                  this.roles.includes('ROLE_SENIOR_DOCTOR')
                  &&
                  [10].includes(afterProcessData.report_category)
                  &&
                  afterProcessData.review_required
                  &&
                  [20, 100].includes(afterProcessData.status)
                  &&
                  [6].includes(+defaultListKey)
                  &&
                  (isMyself(afterProcessData.report_write_doctor_id) || isMyself(afterProcessData.report_review_doctor_id))"
              >召回</Button>
              <Button
                size="large"
                @click="goBackReport"
                v-if="
                  this.roles.includes('ROLE_SENIOR_DOCTOR')
                  &&
                  [5, 15].includes(afterProcessData.report_category)
                  &&
                  [20, 100].includes(afterProcessData.status)
                  &&
                  [6].includes(+defaultListKey)
                  &&
                  (isMyself(afterProcessData.report_write_doctor_id) || isMyself(afterProcessData.report_review_doctor_id))"
              >召回</Button>
            </Col>
            <Col :span="16" style="text-align: right;">
              <Button size="large" @click="auditCancel" style="margin-right: 16px;">返回</Button>
              <Button
                v-if="
                  ![6].includes(+defaultListKey)
                  &&
                  role.afterReview
                  &&
                  [5, 15].includes(afterProcessData.report_category)
                  &&
                  [30].includes(afterProcessData.status)
                  &&
                  afterProcessData.review_required
                  &&
                  (isMyself(afterProcessData.report_write_doctor_id) || isMyself(afterProcessData.report_review_doctor_id))"
                size="large"
                @click="notAuditPass"
                style="margin-right: 16px;"
              >不通过</Button>
              <Button
                v-if="
                  ![6].includes(+defaultListKey)
                  &&
                  [5, 15].includes(afterProcessData.report_category)
                  &&
                  role.afterWrite
                  &&
                  afterProcessData.review_required
                  &&
                  afterProcessData.status === 10
                  &&
                  (isMyself(afterProcessData.report_write_doctor_id) || isMyself(afterProcessData.report_review_doctor_id))"
                size="large"
                @click="auditCommit('audit')"
                style="margin:0 16px;"
                >提交审核</Button>
              <Button
                  v-if="
                    ![6].includes(+defaultListKey)
                    &&
                    role.afterReview
                    &&
                    [10, 30].includes(afterProcessData.status)
                    &&
                    afterProcessData.review_required
                    &&
                    (isMyself(afterProcessData.report_write_doctor_id) || isMyself(afterProcessData.report_review_doctor_id))"
                  size="large"
                  @click="auditPass"
                  type="primary"
                >通过</Button>
              <Button
                v-if="
                  ![6].includes(+defaultListKey)
                  &&
                  [5, 15].includes(afterProcessData.report_category)
                  &&
                  role.afterWrite
                  &&
                  !afterProcessData.review_required
                  &&
                  afterProcessData.status === 10
                  &&
                  (isMyself(afterProcessData.report_write_doctor_id) || isMyself(afterProcessData.report_review_doctor_id))"
                size="large"
                @click="auditCommit('send')"
                >发送</Button>
            </Col>
          </Row>
          <Row :gutter="24" v-if="![5].includes(+defaultListKey)">
            <Col :span="8">
              <Button
                style="margin-right:12px"
                size="large"
                @click="giveUp"
                v-if="
                  (this.roles.includes('ROLE_AFTER_DEAL_REPORT') && this.roles.includes('ROLE_AUDIT_REPORT'))
                  &&
                  ![6].includes(+defaultListKey)
                  &&
                  [20, 30].includes(afterProcessData.status)"
              >放弃</Button>
              <Button
                size="large"
                style="margin-right:12px"
                @click="giveUp"
                v-if="
                  this.roles.includes('ROLE_AFTER_DEAL_REPORT')
                  &&
                  ![6].includes(+defaultListKey)
                  &&
                  [10].includes(afterProcessData.status)"
              >放弃</Button>
              <Button
                style="margin-right:12px"
                size="large"
                @click="giveUp"
                v-if="
                  (!this.roles.includes('ROLE_AFTER_DEAL_REPORT') && this.roles.includes('ROLE_AUDIT_REPORT'))
                  &&
                  ![6].includes(+defaultListKey)
                  &&
                  [20, 30].includes(afterProcessData.status)"
              >放弃</Button>
              <!-- 后处理医生 -->
              <Button
                size="large"
                @click="goBackReport"
                v-if="
                  (this.roles.includes('ROLE_AFTER_DEAL_REPORT') && !this.roles.includes('ROLE_AUDIT_REPORT'))
                  &&
                  [5, 15].includes(afterProcessData.report_category)
                  &&
                  [20, 100].includes(afterProcessData.status)
                  &&
                  ![6].includes(+defaultListKey)"
              >召回</Button>
              <Button
                size="large"
                @click="goBackReport"
                v-if="
                  (this.roles.includes('ROLE_AFTER_DEAL_REPORT') && this.roles.includes('ROLE_AUDIT_REPORT'))
                  &&
                  [5, 15].includes(afterProcessData.report_category)
                  &&
                  [20, 100].includes(afterProcessData.status)
                  &&
                  ![6].includes(+defaultListKey)"
              >召回</Button>
              <Button
                size="large"
                @click="goBackReport"
                v-if="
                  (!this.roles.includes('ROLE_AFTER_DEAL_REPORT') && this.roles.includes('ROLE_AUDIT_REPORT'))
                  &&
                  [5, 15].includes(afterProcessData.report_category)
                  &&
                  [100].includes(afterProcessData.status)
                  &&
                  ![6].includes(+defaultListKey)"
              >召回</Button>
              <Button
                size="large"
                @click="goBackReport"
                v-if="
                  (this.roles.includes('ROLE_AFTER_DEAL_REPORT') && this.roles.includes('ROLE_AUDIT_REPORT'))
                  &&
                  [10].includes(afterProcessData.report_category)
                  &&
                  afterProcessData.review_required
                  &&
                  [20, 100].includes(afterProcessData.status)
                  &&
                  ![6].includes(+defaultListKey)"
              >召回</Button>
              <Button
                size="large"
                @click="goBackReport"
                v-if="
                  (this.roles.includes('ROLE_AFTER_DEAL_REPORT') && !this.roles.includes('ROLE_AUDIT_REPORT'))
                  &&
                  [10].includes(afterProcessData.report_category)
                  &&
                  afterProcessData.review_required
                  &&
                  [20, 100].includes(afterProcessData.status)
                  &&
                  ![6].includes(+defaultListKey)"
              >召回</Button>
              <Button
                size="large"
                @click="goBackReport"
                v-if="
                  (!this.roles.includes('ROLE_AFTER_DEAL_REPORT') && this.roles.includes('ROLE_AUDIT_REPORT'))
                  &&
                  [10].includes(afterProcessData.report_category)
                  &&
                  afterProcessData.review_required
                  &&
                  [100].includes(afterProcessData.status)
                  &&
                  ![6].includes(+defaultListKey)"
              >召回</Button>
              <!-- 高级医生 -->
              <Button
                size="large"
                @click="goBackReport"
                v-if="
                  this.roles.includes('ROLE_SENIOR_DOCTOR')
                  &&
                  [10].includes(afterProcessData.report_category)
                  &&
                  afterProcessData.review_required
                  &&
                  [20, 100].includes(afterProcessData.status)
                  &&
                  [6].includes(+defaultListKey)"
              >召回</Button>
              <Button
                size="large"
                @click="goBackReport"
                v-if="
                  this.roles.includes('ROLE_SENIOR_DOCTOR')
                  &&
                  [5, 15].includes(afterProcessData.report_category)
                  &&
                  [20, 100].includes(afterProcessData.status)
                  &&
                  [6].includes(+defaultListKey)"
              >召回</Button>
            </Col>
            <Col :span="16" style="text-align: right;">
              <Button size="large" @click="auditCancel" style="margin-left: 16px;">返回</Button>
              <Button
                v-if="
                  ![6].includes(+defaultListKey)
                  &&
                  role.afterReview
                  &&
                  [5, 15].includes(afterProcessData.report_category)
                  &&
                  [30].includes(afterProcessData.status)
                  &&
                  afterProcessData.review_required"
                size="large"
                @click="notAuditPass"
                style="margin-right: 16px;"
              >不通过</Button>
              <Button
                v-if="
                  ![6].includes(+defaultListKey)
                  &&
                  [5, 15].includes(afterProcessData.report_category)
                  &&
                  role.afterWrite
                  &&
                  afterProcessData.review_required
                  &&
                  afterProcessData.status === 10"
                size="large"
                @click="auditCommit('audit')"
                style="margin:0 16px;"
                >提交审核</Button>
              <Button
                  v-if="
                    ![6].includes(+defaultListKey)
                    &&
                    role.afterReview
                    &&
                    [10, 30].includes(afterProcessData.status)
                    &&
                    afterProcessData.review_required"
                  size="large"
                  @click="auditPass"
                  type="primary"
                  style="margin-left:16px;"
                >通过</Button>
              <Button
                v-if="
                  ![6].includes(+defaultListKey)
                  &&
                  [5, 15].includes(afterProcessData.report_category)
                  &&
                  role.afterWrite
                  &&
                  !afterProcessData.review_required
                  &&
                  afterProcessData.status === 10"
                size="large"
                @click="auditCommit('send')"
                >发送</Button>
            </Col>
          </Row>
        </div>
      </div>
    </Modal>
    <!-- 待审核 -->
    <Modal v-model="auditReport.showModal" :confirmLoading="loading.sureAudit" @ok="sureAudit">
      <slot slot="title">
        <span v-if="auditReport.notImageNum" style="color: #f00;">{{auditReport.title}}</span>
        <span v-else>{{auditReport.title}}</span>
      </slot>
      <div v-if="!auditReport.multiple">
        <p>是否确认领取该报告订单？</p>
        <p>领取后，其他医生将不能再领取</p>
        <p v-if="auditReport.notImageNum">解绑原因：{{reportInfo && reportInfo.lastUnbindMessage}}</p>
      </div>
      <p v-if="auditReport.multiple">{{auditReport.doctorName}} 48小时内曾{{auditReport.reportStatusText}}过该患者的其他报告订单，您是否确定领取当前报告订单？</p>
    </Modal>
    <Modal v-model="showCommitAudit" :confirmLoading="loading.sureCommitAudit" @ok="sureCommitAudit">
      <div v-if="auditType === 'audit'">
        <p>是否提交审核？</p>
        <p>提交审核后，该报告将不能修改</p>
        <p v-if="auditReport.notImageNum">解绑原因：{{reportInfo && reportInfo.lastUnbindMessage}}</p>
      </div>
      <div v-if="auditType === 'send'">
        <p>是否确认发送报告？</p>
        <p>通过发送后，报告将发送至各相关系统。</p>
        <p v-if="auditReport.notImageNum">解绑原因：{{reportInfo && reportInfo.lastUnbindMessage}}</p>
      </div>
    </Modal>
    <Modal title="不通过审核" v-model="showNotPassAudit" :confirmLoading="loading.sureNotAuditPass" @ok="sureNotAuditPass">
      <p>是否确认不通过审核？</p>
      <p>确定之后，报告将由编写医生重写</p>
      不通过原因
      <div class="notPassContent" style="margin-left: 17%; margin-top: -8%;text-align: right;">
        <span>剩余 {{700 - notPassMsg.length}} 字</span>
        <TextArea :maxlength="700" v-model.trim="notPassMsg" :autosize="{ minRows: 5, maxRows: 20 }"></TextArea>
      </div>
    </Modal>
    <Modal title="通过审核" v-model="showAuditPass" :confirmLoading="loading.sureAuditPass" @ok="sureAuditPass">
      <p>是否通过审核？</p>
      <p>通过审核后，报告将发送至各相关系统</p>
    </Modal>
    <Modal title="重新运算" v-model="showRecalculate" :confirmLoading="loading.sureRecalculate" @ok="sureRecalculate">
      <p>是否确认重新运算？</p>
      <p>重新运算可能将加收运算费用</p>
    </Modal>
    <Modal title="删除" v-model="showRemoveReport" :confirmLoading="loading.sureRemoveReport" @ok="sureRemoveReport">
      <p>是否确认删除该报告？</p>
    </Modal>
    <Modal title="召回" v-model="recall.openFlag" :confirmLoading="loading.recallAction" @cancel="recallCancel" @ok="recallAction">
      <p>是否确认报告召回？</p>
      <p>确认召回后，报告将回到”{{recall.targetAddress}}“状态</p>
    </Modal>
    <!-- 放弃编写弹框 -->
    <Modal title="放弃" v-model="giveUpModal.openFlag" @cancel="cancelGiveUp">
      <div slot="footer">
        <div v-if="!giveUpModal.multiple">
          <Button size="large" @click="cancelGiveUp">取消</Button>
          <Button size="large" type="primary" :loading="loading.giveUpCurrent" @click="giveUpCurrent">确认</Button>
        </div>
        <div v-if="giveUpModal.multiple">
          <Button size="large" @click="cancelGiveUp">取消</Button>
          <Button size="large" type="primary" :loading="loading.giveUpCurrent" @click="giveUpCurrent">只放弃当前报告</Button>
          <Button size="large" type="primary" :loading="loading.giveUpAll" @click="giveUpAll">全部放弃</Button>
        </div>
      </div>
      <div v-if="!giveUpModal.multiple">
        <p>是否放弃{{giveUpModal.type}}报告？</p>
        <p>放弃后，报告将由其他医生完成{{giveUpModal.type}}</p>
      </div>
      <div v-if="giveUpModal.multiple">
        <p>该检查共有 {{giveUpModal.tableData.length}} 个处理中的报告订单，您是否全部放弃？</p>
        <p>放弃后，该报告将由其他医生完成{{giveUpModal.type}}</p>
        <Table :columns="giveUpModal.tableColumns" :dataSource="giveUpModal.tableData" bordered :pagination=false rowKey="id">
          <template slot="cate" slot-scope="text, record">
            {{record.report_category|reportType}}
          </template>
          <template slot="label" slot-scope="text, record">
            {{record.base_element_name}}
          </template>
        </Table>
      </div>
    </Modal>
    <!-- 查看不通过原因 -->
    <Modal title="不通过原因" v-model="notPassWhy.showNotPassWhy">
      <div class="notPassList">
        <Table bordered :pagination="false" :dataSource="notPassWhy.notPassList" :columns="notPassWhy.columns" rowKey="review_date"></Table>
      </div>
      <div slot="footer">
        <Button type="primary" @click="cancelNotPassWhy">确定</Button>
      </div>
    </Modal>
    <!-- 预约列表 -->
    <Modal title="营业点预约列表" v-model="appointment.showModal" width="800px" :footer="null" class="appointmentListModal">
      <div>
        <div style="margin-bottom: 12px;">
          <DatePicker style="margin-right: 12px;" @change="changeAppointmentDate" :default-value="appointment.date" format="YYYY-MM-DD"></DatePicker>
          <Select showArrow :getCalendarContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" style="width: 220px;" v-model="appointment.hospitalId" @change="getAppointmentList">
            <Option v-for="(val, index) in searchOption.checkHospitalList" :key="index" :value="val.hospital_id">{{val.name}}</Option>
          </Select>
        </div>
        <Table bordered :pagination="false" :scroll="{ y: 340 }" :dataSource="appointment.list" :columns="appointment.tableColumns" rowKey="review_date">
          <template slot="examineFinishFlag" slot-scope="text, record">
            {{record.status|scanningStatus}}
          </template>
          <template slot="report_status" slot-scope="text, record">
            {{record.report_status === 20 ? '已发报告': '未发报告'}}
          </template>

        </Table>
      </div>
    </Modal>
    <!-- 显示预约列表 -->
    <div class="watchAppointmentList">
      <Button type="primary" @click="showAppoointmentList">预约列表</Button>
    </div>
    <Modal title="AI报告编写" v-model="writeAiReportFlag" width="804px" class="aiEditReportModal" :maskClosable="false" :zIndex="parseInt(1000)">
      <AiReportForm  v-if="writeAiReportFlag" :reportId="activeId" :checkItemName="reportInfo.reportInfo.check_item_name" :reportParams="reportInfo.reportInfo?reportInfo.reportInfo.report_materials : ''" ref="AiReportForm"/>
      <template slot="footer">
        <Button key="back" @click="() => writeAiReportFlag = false">取消</Button>
        <Button key="submit" type="primary" :loading="uploadAiReportLoading" :disabled="uploadAiReportLoading" @click="submitAiReportParams">确定</Button>
      </template>
    </Modal>
  </div>
</template>
<script>
import { receiveCheck, receiveReport, reportPass, rejectReport, giveUpReport } from '../../api/reportAudit'
import { getHisAAllReportList, getProcessingReportList, getWaitingForTakeReportList, getMyProcessingReportList, getMyFinishedReportList, getStaticData } from '../../api/reportList'
import leftArticle from '../../components/reportSearch'
import { Row, Col, Button, Tabs, Modal, Input, Upload, Table, Progress, Select, DatePicker } from 'ant-design-vue'
import { toast, switchTimeFormat, getSession, openNewWindow, setSession, getParamFromRoute, downLoadFile as utilDownLoadFile } from '../../libs/utils'
import { operation, getMyWritingTask, reeceiveReport, commitReportReview, viewAuditNotPassWhy, removeUpLoadReport, recall, getUploadList, downloadImage, giveUpAllWriting, giveUpWriting, getReportPatientInfo, uploadReport, uploadSliceReport } from '../../api/report'
import { WatchImageByWeasisOrOsrix, QueueList } from '../../libs/mixin'
import { getWriteDoctorList, getCheckDevice, getImageCenterList, getDiagnosedList } from '../../api/check'
import { findIndex, differenceBy, pullAllBy } from 'lodash'
import moment from 'moment'
import { sliceFile } from '../../libs/tool'
import { getNewSystemList } from '../../api/onlineOperation'
import AiReportForm from './aiReportForm.vue'
export default {
  mixins: [WatchImageByWeasisOrOsrix, QueueList],
  components: {
    Row,
    Col,
    leftArticle,
    Button,
    Tabs,
    TabPane: Tabs.TabPane,
    Modal,
    TextArea: Input.TextArea,
    Upload,
    Table,
    Progress,
    Select,
    Option: Select.Option,
    DatePicker,
    AiReportForm
  },
  data () {
    return {
      defaultListKey: 1, // 默认展示的tab页
      operateList: [], // 运算中列表
      handerList: [], // 处理中列表
      myReportList: [], // 我的报告列表
      hisList: [], // 历史列表
      allList: [], // 全部列表
      waitingList: [],
      staticData: null, // 统计数据
      selectItem: { // 选中的列表数据
        status: ''
      },
      receiveReport: { // 待编写弹框
        title: '领取报告订单',
        reportStatusText: '编写',
        showModal: false,
        multiple: false,
        showHandler: false,
        doctorName: '',
        notImageNum: false
      },
      afterReport: { // 待编写弹框
        title: '领取报告订单',
        reportStatusText: '编写',
        showModal: false,
        multiple: false,
        showHandler: false,
        doctorName: '',
        notImageNum: false
      },
      auditReport: { // 待审核弹框
        title: '领取报告订单',
        reportStatusText: '审核',
        showModal: false,
        multiple: false,
        showHandler: false,
        showFooter: undefined,
        doctorName: '',
        notImageNum: false
      },
      reportInfo: {}, // 选中的报告新
      showNotPassAudit: false, // 展示不通过弹框
      notPassMsg: '', // 审核不通过原因
      showRemoveReport: false, // 展示删除弹框
      showAuditPass: false, // 展示审核不通过弹框
      showRecalculate: false, // 展示重新运算弹框
      pageNo: 1,
      pageSize: 10,
      totalCount: 0,
      totalPage: 1,
      searchData: {}, // 搜索条件
      image: {
        showViewReport: false,
        viewReportUrl: '',
        fileSuffix: ''
      },
      imageList: [],
      fileData: {},
      roles: [],
      recall: { // 召回参数
        openFlag: false,
        targetAddress: '编写中'
      },
      role: {},
      giveUpModal: { // 放弃弹窗
        multiple: false,
        openFlag: false,
        type: '编写',
        tableColumns: [
          {
            title: '报告类型',
            dataIndex: 'cate',
            key: 'cate',
            scopedSlots: { customRender: 'cate' }
          },
          {
            title: 'AI算法',
            dataIndex: 'label',
            key: 'label',
            scopedSlots: { customRender: 'label' }
          }
        ],
        tableData: [],
      },
      activeId: null,
      showCommitAudit: false,
      auditType: '',
      downImageLoad: false,
      historyReportList: [],
      searchOption: { // 搜索条件
        writeDoctorList: [], //编写医生
        diagnosisList: [],
        deviceList: [],
        checkHospitalList: []
      },
      timerFlag: null,
      notPassWhy: {
        showNotPassWhy: false, // 不通过原因弹框
        notPassList: [],
        columns: [
          {
            title: '审核时间',
            key: 'review_date',
            dataIndex: 'review_date',
            align: 'center'
          },
          {
            title: '审核医生',
            key: 'report_review_doctor_name',
            dataIndex: 'report_review_doctor_name',
            align: 'center'
          },
          {
            title: '不通过原因',
            key: 'deny_comment',
            dataIndex: 'deny_comment',
            align: 'center'
          }
        ]
      },
      routeParams: {},
      afterProcessData: {},
      loading: {
        sureReceive: false,
        sureAudit: false,
        sureCommitAudit: false,
        sureNotAuditPass: false,
        sureAuditPass: false,
        sureRecalculate: false,
        sureRemoveReport: false,
        recallAction: false,
        giveUpCurrent: false,
        giveUpAll: false,
        uploadFile: false
      },
      uploadReportProgress: 0,
      appointment: {
        showModal: false,
        hospitalId: '',
        date: moment(),
        list: [],
        hospitalList: [],
        tableColumns: [
          {
            title: '时间',
            dataIndex: 'service_appointment_actual_datetime',
            key: 'service_appointment_actual_datetime',
            width: 140
          },
          {
            title: '姓名',
            dataIndex: 'patient_name',
            key: 'patient_name',
            width: 100
          },
          {
            title: '检查部位',
            dataIndex: 'check_item_selected_name',
            key: 'check_item_selected_name'
          },
          {
            title: '检查状态',
            dataIndex: 'status',
            key: 'status',
            width: 120,
            scopedSlots: { customRender: 'examineFinishFlag' }
          },
          {
            title: '报告状态',
            dataIndex: 'report_status',
            key: 'report_status',
            width: 120,
            scopedSlots: { customRender: 'report_status' }
          },

        ]
      },
      writeAiReportFlag: false,
      uploadAiReportLoading: false
    }
  },
  async mounted () {
    this.roleIsShowBtn()
    this.role = this.getDoctorRoles()
    await this.initSearchOption()
    await this.initData()
  },
  beforeDestroy () {
    if (this.timerFlag) clearInterval(this.timerFlag)
    this.timeFlag = null
  },
  methods: {
    async initData () {
      let routeParams = getParamFromRoute(this.$route)
      this.routeParams = routeParams
      if (routeParams.pageNo) this.pageNo =  parseInt(routeParams.pageNo, 10)
      if (routeParams.curKey) this.defaultListKey = routeParams.curKey.toString()
      if (routeParams.activeId) this.selectItem.id = parseInt(routeParams.activeId, 10)
      if (!getSession('browerReportList') || !routeParams.curKey) this.getRoleTabs()
      let searchData = getSession('searchReportData', 'object') || null
      if (searchData) {
        this.searchData = {
          nameOrBody: searchData.nameOrBody || '',
          diagnosis: searchData.diagnosis || undefined,
          startAEndTime: searchData.startAEndTime && searchData.startAEndTime.length > 0 ? [moment(searchData.startAEndTime[0]), moment(searchData.startAEndTime[1])] : [],
          device: searchData.device || undefined,
          checkHospital: searchData.checkHospital || undefined,
          writeDoctor: searchData.writeDoctor || undefined,
          reportType: searchData.reportType || undefined,
          reportStatus: searchData.reportStatus || undefined,
          dateType: searchData.dateType || 1
        }
      }
      await this.curKeyGetList()
    },
    async initSearchOption () {
      let doctorList = await getWriteDoctorList({ roleId: 9, pageNumber: 1, pageSize: 9999 })
      if (doctorList && doctorList.results) this.searchOption.writeDoctorList = doctorList.results || []
      let diagnosisList = await getDiagnosedList({ pageNumber: 1, pageSize: 999 })
      if (diagnosisList && diagnosisList.results) this.searchOption.diagnosisList = diagnosisList.results
      let deviceList = await getCheckDevice()
      if (deviceList && deviceList.length > 0) this.searchOption.deviceList = deviceList
      let checkHospitalList = await getImageCenterList()
      if (checkHospitalList && checkHospitalList.results) this.searchOption.checkHospitalList = checkHospitalList.results
    },
    resetCheckList (curKey) {
      if (curKey == 1) return this.operateList = []
      if (curKey == 2) return this.waitingList = []
      if (curKey == 3) return this.handerList = []
      if (curKey == 4) return this.myReportList = []
      if (curKey == 5) return this.hisList = []
      if (curKey == 6) return this.allList = []
    },
    // 切换tab
    async changCheckCate (curKey) {
      this.pageNo = 1
      this.totalCount = 0
      this.defaultListKey = curKey
      this.activeId = null
      this.selectItem.id = null
      sessionStorage.removeItem('searchReportData')
      this.searchData = {}
      this.resetCheckList(curKey)
      await this.curKeyGetList()
    },
    // 选中表格中的一项的数据
    async selectItemData (params) {
      if (!params || !params.data || !params.data.id) return false
      this.selectItem = params.data
      this.activeId = params.data.id
      this.setCurrentUrl({curKey: this.defaultListKey, pageNo: this.pageNo, totalCount: this.totalCount, activeId: this.activeId})
      await this.getReportInfo()
      this.notImageReportTitle(this.reportInfo)
    },
    // 判断没有影像的报告的领取弹框标题
    notImageReportTitle (data) {
      if (!data) return false
      let filmNum = data.reportInfo && data.reportInfo.matched_film_no
      if (!filmNum || filmNum === '') {
        this.receiveReport.title = '领取报告订单-暂无影像'
        this.receiveReport.notImageNum = true
        this.auditReport.title = '领取报告订单-暂无影像'
        this.auditReport.notImageNum = true
        this.afterReport.title = '领取报告订单-暂无影像'
        this.afterReport.notImageNum = true
      } else {
        this.receiveReport.title = '领取报告订单'
        this.receiveReport.notImageNum = false
        this.auditReport.title = '领取报告订单'
        this.auditReport.notImageNum = false
        this.afterReport.title = '领取报告订单'
        this.afterReport.notImageNum = false
      }
    },
    // 搜索条件
    async searchReportData (data) {
      this.pageNo = 1
      this.searchData = data
      await this.curKeyGetList()
    },
    // 重新运算
    async handleRecalculate (type) {
      if (!this.selectItem.id) return toast({ title: '提示', msg: '请选中报告！', type: 'warning' })
      if (type === 'all') {
        if (this.isControl('cancel')) {
          this.showRecalculate = true
        }
      } else {
        this.showRecalculate = true
      }
    },
    // 确认重新运算
    async sureRecalculate () {
      try {
        this.loading.sureRecalculate = true
        let data = await operation({ id: this.afterProcessData.id || this.selectItem.id })
        if (!data) throw Error('sureRecalculate方法Error')
        this.showRecalculate = false
        this.closeAllModal()
        toast({ title: '提示', msg: '启动重新运算成功！', type: 'warning' })
        await this.curKeyGetList()
      } catch (error) {
        console.log('sureRecalculate', error)
      } finally {
        this.loading.sureRecalculate = false
      }
    },
    // 查看不通过原因
    async viewNotPass () {
      let data = await this.viewAuditNoPass()
      if (data && data.length > 0) {
        this.notPassWhy.showNotPassWhy = true
        this.notPassWhy.notPassList = data
      }
    },
    // 关闭查看不通过原因弹框
    cancelNotPassWhy () {
      this.notPassWhy.showNotPassWhy = false
    },
    // 编写报告
    async writeReport () {
      if (!this.selectItem.id) toast({ title: '提示', msg: '请选中列表中其中一个报告！', type: 'warning' })
      this.isControl('write')
      // 常规报告
      if (this.selectItem.report_category === 1) {
        this.conventionalDisease()
      } else if (this.selectItem.report_category === 5 || this.selectItem.report_category === 15) { // 非自动化
        this.notAutomation()
      }
      if ([10].includes(this.selectItem.status) && this.selectItem.report_category === 1) {
        this.$router.push({path: '/ris/edit', query: {reportId: this.selectItem.id, from: 'writing'}})
      }
    },
    // 编写确定领取报告
    async sureReceive () {
      this.loading.sureReceive = true
      try {
        let data = await reeceiveReport({id: this.selectItem.id, instanceId: this.selectItem.process_instance_id})
        if (data && (this.selectItem.report_category === 5 || this.selectItem.report_category === 15)) {
          this.selectItem.status = 10
          this.afterProcessData.status = 10
          this.pageNo = 1
          this.notAutomationToWrite()
        } else if (data && data.id) {
          toast({ title: '提示', msg: `领取患者${this.selectItem.patient_name}的报告成功`, type: 'success' })
          this.loading.sureReceive = false
          this.$router.push({path: '/ris/edit', query: { reportId: data.id, from: 'writing' }})
        } else {
          throw Error('编写确定领取报告错误')
        }
        this.receiveReport.showModal = false
      } catch (error) {
        console.log(error)
      } finally {
        this.loading.sureReceive = false
      }
    },
    // 审核确定领取报告
    async sureAudit () {
      try {
        this.loading.sureAudit = true
        if (this.selectItem.status === 20) {
          await this.sureReceiveReport()
        }
        if (this.selectItem.status === 20 && this.selectItem.report_category !== 1) {
          this.selectItem.status = 30
          this.afterProcessData.status = 30
          this.notAutomationToAudit()
        }
        this.receiveReport.showModal = false
        this.auditReport.showModal = false
      } catch (error) {
        console.log(error)
      } finally {
        this.loading.sureAudit = false
      }
    },
    // 审核报告
    audit () {
      if (!this.selectItem.id) toast({ title: '提示', msg: '请选中列表中其中一个报告！', type: 'warning' })
      this.isControl('audit')
      let userInfo = getSession('risUserInfo', 'object')
      if (this.selectItem && this.selectItem.report_review_doctor_name) {
        if (this.selectItem && this.selectItem.report_review_doctor_id !== userInfo.id && this.selectItem.status === 30) return toast({ title: '提示', msg: `该报告${this.selectItem && this.selectItem.report_review_doctor_name}正在审核中！`, type: 'warning' })
      }
      if (this.role.write && !this.role.review && this.selectItem.status === 30) return toast({type: 'warning', msg: '您没有审核权限，不能查看！'})
      if (this.selectItem.report_category === 1) {
        this.conventionalDisease()
      } else if (this.selectItem.report_category === 5 || this.selectItem.report_category === 15) {
        this.notAutomation()
      } else if (this.selectItem.report_category === 10) {
        this.automation()
      }
      if ([30].includes(this.selectItem.status) && this.selectItem.report_category === 1) {
        this.$router.push({path: '/ris/edit', query: {reportId: this.selectItem.id}})
      }
    },
    // 判断操作权限
    isControl (type) {
      if (type === 'write' && !(this.roles.includes('ROLE_AFTER_DEAL_REPORT') || this.roles.includes('ROLE_WRITE_REPORT'))) {
        toast({title: '提示', type: 'warning', msg: '您没有编写权限，无法进行编写！'})
        return false
      } else if (type === 'audit' && !(this.roles.includes('ROLE_AFTER_DEAL_REPORT') || this.roles.includes('ROLE_AUDIT_REPORT'))) {
        toast({title: '提示', type: 'warning', msg: '您没有审核权限，无法进行审核！'})
        return false
      } else if (type === 'view' && ![100].includes(this.selectItem.status)) {
        toast({title: '提示', type: 'warning', msg: '该报告非已完成，无法查看！'})
        return false
      } else if ((type === 'cancel')) {
        if ([1, 10, 30].includes(this.selectItem.status) && this.selectItem.report_category === 1) {
          toast({title: '提示', type: 'warning', msg: '该报告无法查看！'})
          return false
        } else if ([0, -99, 1, 10, 20, 30].includes(this.selectItem.status) && this.selectItem.report_category !== 1) {
          toast({title: '提示', type: 'warning', msg: '该报告无法查看！'})
          return false
        }
        return true
      } else if (type === 'my') {
        return true
      } else return true
    },
    // 查看报告
    viewsReport (type) {
      if (!this.selectItem.id) return toast({ title: '提示', msg: '请选中列表中其中一个报告！', type: 'warning' })
      if (type === 'all') {
        if (this.isControl('cancel')) {
          this.isShowView()
        }
      } else if (type === 'mySelf') {
        if (this.isControl('my')) {
          this.isShowView()
        }
      } else {
        if (this.isControl('view')) {
          this.isShowView()
        }
      }
    },
    // 判断查看逻辑
    isShowView () {
      if (this.selectItem.report_category === 5 || this.selectItem.report_category === 15) {
        this.notAutomation()
      } else if (this.selectItem.report_category === 10) {
        this.automation()
      } else {
        this.$router.push({ path: '/ris/edit', query: {reportId: this.selectItem.id} })
      }
    },
    // 下载
    downFile (url) {
      window.open(url, '_blank')
      // return downLoadFile(url, name)
    },
    // 删除影像
    removeImage (image, index) {
      this.fileData = { fileName: image.name, index: index }
      this.showRemoveReport = true
    },
    // 确认删除影像
    async sureRemoveReport () {
      try {
        this.loading.sureRemoveReport = true
        let data = await removeUpLoadReport({ id: this.afterProcessData.id, reportFileName: this.fileData.fileName })
        if (!data) throw Error('确认删除影像错误')
        this.showRemoveReport = false
        this.loading.sureRemoveReport = false
        this.imageList.splice(this.fileData.index, 1)
        await this.upLoadList()
      } catch (error) {
        console.log(error)
      } finally {
        this.loading.sureRemoveReport = false
      }
    },
    // 常规诊断
    async conventionalDisease () {
      if (this.selectItem.status === 1) {
        await this.toWrite()
      } else if (this.selectItem.status === 20) {
        await this.toAudit()
      }
    },
    // 后处理报告医生我的报告审核查看
    handlerViewMyReport (type) {
      if (type === 'mySelf') {
        if (this.isControl('my')) {
          this.notAutomationToAudit()
        }
      }
    },
    // 非自动化
    async notAutomation () {
      this.receiveReport.title = 'AI算法'
      this.roleIsShowBtn()
      if (this.selectItem.status === 1) {
        await this.toWrite()
      } else if (this.selectItem.status === 20) {
        await this.toAudit()
      } else if (this.selectItem.status === 10) {
        await this.notAutomationToWrite()
        await this.viewNotPass()
      } else if (this.selectItem.status === 30) {
        await this.notAutomationToAudit()
      } else if (this.selectItem.status === 100) {
        this.notAutomationToAudit()
      }
    },
    // 自动化
    async automation () {
      this.receiveReport.title = 'AI算法'
      this.roleIsShowBtn()
      if (this.selectItem.status === 20) {
        await this.toAudit()
      } else if (this.selectItem.status === 30) {
        await this.notAutomationToAudit()
      } else if (this.selectItem.status === 100) {
        this.notAutomationToAudit()
      }
    },
    // 点击编写按钮
    async toWrite () {
      let curUserId = getSession('risUserInfo', 'object').id
      if (this.reportInfo.historyReports && this.reportInfo.historyReports.length > 0) {
        this.reportInfo.historyReports.forEach(val => {
          if (val.report_write_doctor_id && val.report_write_doctor_name && (val.report_write_doctor_id !== curUserId)) {
            this.receiveReport.multiple = true
            this.receiveReport.doctorName = val.report_write_doctor_name
          } else {
            this.receiveReport.multiple = false
          }
        })
      } else {
        this.receiveReport.multiple = false
      }
      this.receiveReport.reportStatusText = '编写'
      this.receiveReport.showModal = true
    },
    // 点击审核按钮
    async toAudit () {
      let curUserId = getSession('risUserInfo', 'object').id
      if (this.reportInfo.historyReports && this.reportInfo.historyReports.length > 0) {
        this.reportInfo.historyReports.forEach(val => {
          if (val.report_review_doctor_id && val.report_review_doctor_name && (val.report_review_doctor_id !== curUserId)) {
            this.auditReport.multiple = true
            this.auditReport.doctorName = val.report_review_doctor_name
          } else {
            this.auditReport.multiple = false
          }
        })
      } else {
        this.auditReport.multiple = false
      }
      this.auditReport.reportStatusText = '审核'
      this.auditReport.showModal = true
    },
    // 非自动后处理待编写
    async notAutomationToWrite () {
      this.loading.sureReceive = true
      let data = await getReportPatientInfo({ id: this.activeId })
      if (data && data.reportInfo) {
        this.afterProcessData = data.reportInfo
        this.loading.sureReceive = false
        this.afterReport.showModal = true
        this.afterReport.multiple = false
        this.afterReport.showHandler = true
        this.afterReport.showFooter = null
        this.afterReport.title = 'AI算法'
        await this.upLoadList()
      }
    },
    // 非自动后和自动后处理待审核
    async notAutomationToAudit () {
      this.loading.sureAudit = true
      let data = await getReportPatientInfo({ id: this.activeId })
      if (data && data.reportInfo) {
        this.afterProcessData = data.reportInfo
        this.loading.sureAudit = false
        this.afterReport.showModal = true
        this.afterReport.multiple = false
        this.afterReport.showHandler = true
        this.afterReport.showFooter = null
        this.afterReport.title = 'AI算法'
        await this.upLoadList()
      }
    },
    // 自动后处理待审核关闭领取弹框
    async auditCancel () {
      this.afterReport.showModal = false
      this.auditReport.showModal = false
      await this.curKeyGetList()
    },
    // 自动后处理审核不通过
    notAuditPass () {
      this.showNotPassAudit = true
    },
    // 自动后处理审核确定不通过
    async sureNotAuditPass () {
      await this.sureNotPassAudit()
      this.closeAllModal()
      await this.curKeyGetList()
    },
    // 自动后处理审核通过
    auditPass () {
      this.showAuditPass = true
    },
    // 自动后处理审核确认通过
    async sureAuditPass () {
      await this.surePassAudit()
      this.closeAllModal()
      await this.curKeyGetList()
    },
    // 确定通过审核
    async surePassAudit () {
      try {
        this.loading.sureAuditPass = true
        let params = { reportId: this.afterProcessData.id }
        let data = await reportPass(params)
        if (!data) throw Error('确定通过审核错误')
        toast({ title: '提示', msg: '审核报告通过！', type: 'success' })
      } catch (error) {
        console.log(error)
      } finally {
        this.loading.sureAuditPass = false
      }
    },
    // 确定不通过审核
    async sureNotPassAudit () {
      try {
        this.loading.sureNotAuditPass = true
        let params = { reportId: this.afterProcessData.id }
        if (this.notPassMsg) params.denyComment = this.notPassMsg
        let data = await rejectReport(params)
        if (!data) throw Error('确定不通过审核错误')
        toast({ title: '提示', msg: '审核报告驳回成功！', type: 'success' })
      } catch (error) {
        console.log(error)
      } finally {
        this.loading.sureNotAuditPass = false
      }
    },
    // 后处理审核提交
    auditCommit (type) {
      this.auditType = type
      this.showCommitAudit = true
    },
    // 确定后处理审核提交
    async sureCommitAudit () {
      this.loading.sureCommitAudit = true
      let data = await commitReportReview({ id: this.afterProcessData.id })
      if (data) {
        this.loading.sureCommitAudit = false
        toast({ title: '提示', msg: '提交审核成功！', type: 'success' })
        await this.curKeyGetList()
      }
      this.closeAllModal()
    },
    // 后处理审核重新计算
    toOperation () {
      this.showRecalculate = true
    },
    // 后处理审核下载影像
    async downImage () {
      this.downImageLoad = true
      let data = await downloadImage({ orderCheckId: this.afterProcessData.order_check_id })
      if (data) {
        utilDownLoadFile(data)
        // this.downFile(data)
        this.downImageLoad = false
      } else {
        this.downImageLoad = false
        toast({ type: 'error', title: '提示', msg: '该报告没有影像！' })
      }
    },
    beforeUpload(file) {
      this.loading.uploadFile = true
      this.uploadFileAction(file)
      return false
    },
    async uploadFileAction(file) {
      // 小于20M的不分片传输
      if (file.size <= 20 * 1024 * 1024) {
        await uploadReport({file: file, id: this.afterProcessData.id})
      } else {
        let sliceInfo = await sliceFile(file)
        let params = {
          id: this.afterProcessData.id,
          size: file.size,
          total: sliceInfo.sliceNum,
          fileMd5: sliceInfo.originFileMd5,
          name: file.name
        }
        let perProData = Math.floor(100 / sliceInfo.sliceNum)
        for(let i = 0; i < sliceInfo.sliceNum; i++) {
          let chunkItem = sliceInfo.chunkArr[i]
          params.file = chunkItem.file
          params.md5 = chunkItem.md5
          params.index = chunkItem.index
          params.action = 'check'
          let data = await uploadSliceReport(params)
          if (!data)  {
            toast({msg: '分片上传文件检测异常，请重新上传', type: 'error', title: '错误提示'})
            this.loading.uploadFile = false
            this.uploadReportProgress = 0
            return false
          }
          params.action = 'upload'
          let uploadData = await uploadSliceReport(params)
          if (!uploadData) {
            toast({msg: '分片上传文件异常，请重新上传', type: 'error', title: '错误提示'})
            this.loading.uploadFile = false
            this.uploadReportProgress = 0
            return false
          }
          this.uploadReportProgress += perProData
        }
      }
      this.uploadReportProgress = 100
      toast({msg: '上传报告成功', type: 'success', title: '操作提示'})
      await this.upLoadList()
      this.loading.uploadFile = false
      this.uploadReportProgress = 0
    },
    // 搜索条件
    searchConditions () {
      let param = {}
      if (this.searchData.diagnosis && this.searchData.diagnosis.length > 0) param.diagnoseCenterIds = this.searchData.diagnosis
      if (this.searchData.device && this.searchData.device.length > 0) param.deviceCategoryIds = this.searchData.device
      if (this.searchData.checkHospital && this.searchData.checkHospital.length > 0) param.hospitalIds = this.searchData.checkHospital
      if (this.searchData.writeDoctor && this.searchData.writeDoctor.length > 0) param.reportWriteDoctorIds = this.searchData.writeDoctor
      if (this.searchData.reportType && this.searchData.reportType.length > 0) param.reportCategoryIds = this.searchData.reportType
      if (this.searchData.reportStatus && this.searchData.reportStatus.length > 0) param.statuses = this.searchData.reportStatus
      if (this.searchData.nameOrBody) param.search = this.searchData.nameOrBody
      if (this.searchData.startAEndTime && this.searchData.startAEndTime.length > 0 && this.searchData.dateType) param.dateType =  this.searchData.dateType === 1 ? 'launch' : 'complete'
      if (this.searchData.startAEndTime && this.searchData.startAEndTime.length > 0) {
        param.startDate = switchTimeFormat(this.searchData.startAEndTime[0], 1) + ' 00:00:00',
        param.endDate = switchTimeFormat(this.searchData.startAEndTime[1], 1) + ' 23:59:59'
      }
      return param
    },
    async findAndChooseSelectItem (data) {
      let selectData = data[0] || {}
      let listIndex = 0
      if ((!this.selectItem || !this.selectItem.id) && this.pageNo == 1) return this.selectItemData({data: selectData})
      let index = findIndex(data, {id: this.selectItem.id})
      if (index != -1) {
        listIndex = index
        selectData = data[listIndex]
      }
      return this.selectItemData({data: selectData})
    },
    // 获取预处理报告列表
    async getProcessingReportData(params) {
      await this.staticGetData('PREPROCESSING')
      let data = await getProcessingReportList(params)
      if (!data || !data.results || (data.results.length <= 0 && this.pageNo <= 1)) {
        this.totalCount = 0
        return this.operateList = []
      } else if (data.results.length <= 0) {
        --this.pageNo
        this.setCurrentUrl({curKey: this.defaultListKey, pageNo: this.pageNo, listIndex: 0, totalCount: this.totalCount})
        return await this.curKeyGetList()
      }
      this.totalCount = data.totalRecord
      data.results.pageFlag = 'preProcessing'
      this.operateList = data.results
      await this.findAndChooseSelectItem(data.results)
    },
    // 获取待领取报告列表
    async getWaitingForTakeReportData(params) {
      await this.staticGetData('WAIT')
      let data = await getWaitingForTakeReportList(params)
      if (!data || !data.results) return false
      if (data.pageNo != this.pageNo) return false
      if (data.results.length <= 0 && this.pageNo === 1) {
        this.totalCount = 0
        return this.waitingList = []
      }
      if (this.pageNo > 1 && data.results.length <= 0) {
        --this.pageNo
        return await this.curKeyGetList()
      }
      let newDatas = differenceBy(data.results, this.waitingList, 'id')
      let oldList = differenceBy(this.waitingList, data.results, 'id')
      if (newDatas.length === 0 && oldList.length === 0) return true
      if (oldList.length > 0) {
        pullAllBy(this.waitingList, oldList, 'id')
      }
      if (newDatas.length > 0) {
        newDatas.forEach(item => {
          this.waitingList.unshift(item)
        })
        this.waitingList.sort(function(a, b){
          if (a.created_date > b.created_date) {
            return -1
          } else if (a.created_date < b.created_date) {
            return 1
          } else {
            return 0
          }
        })
      }
      this.totalCount = data.totalRecord || 0
      await this.findAndChooseSelectItem(this.waitingList)
    },
    // 获取处理中报告列表
    async getMyProcessingReportData(params) {
      await this.staticGetData('PROCESSING')
      let data = await getMyProcessingReportList(params)
      if (!data || !data.results || (data.results.length <= 0 && this.pageNo <= 1)) {
        this.totalCount = 0
        return this.handerList = []
      } else if (data.results.length <= 0) {
        --this.pageNo
        this.setCurrentUrl({curKey: this.defaultListKey, pageNo: this.pageNo, listIndex: 0, totalCount: this.totalCount})
        return await this.curKeyGetList()
      }
      this.totalCount = data.totalRecord
      this.handerList = data.results
      this.findAndChooseSelectItem(data.results)
    },
    // 获取我的报告列表
    async getMyFinishedReportData(params) {
      await this.staticGetData('MY')
      let data = await getMyFinishedReportList(params)
      if (!data || !data.results || data.results == 0) {
        this.totalCount = 0
        return this.myReportList = []
      }
      this.totalCount = data.totalRecord
      this.myReportList = data.results
      this.findAndChooseSelectItem(data.results)
    },
    // 获取全部报告列表
    async getAllList (params) {
      await this.staticGetData('ALL')
      let data = await getHisAAllReportList(params)
      if (!data || !data.results) {
        this.totalCount = 0
        return this.allList = []
      }
      this.totalCount= data.totalRecord
      this.totalPage = data.totalPage
      this.totalCount = data.totalRecord
      this.allList = data.results
      this.findAndChooseSelectItem(data.results)
    },
    // 获取历史报告列表
    async getHisReportList (params) {
      await this.staticGetData('HISTORY')
      let data = await getHisAAllReportList(params)
      if (!data || !data.results || data.results == 0) {
        this.totalCount = 0
        return this.hisList = []
      }
      this.totalCount = data.totalRecord
      this.hisList = data.results
      await this.findAndChooseSelectItem(data.results)
    },
    // 根据当前所在的tab页调取列表接口
    async curKeyGetList () {
      if (this.timerFlag) {
        clearInterval(this.timerFlag)
        this.timeFlag = null
      }
      let params = {
        pageNumber: this.pageNo,
        pageSize: this.pageSize,
      }
      Object.assign(params, this.searchConditions())
      if (this.defaultListKey === '1') {
        await this.getProcessingReportData(params)
      } else if (this.defaultListKey === '2') {
        if (this.timerFlag) {
          clearInterval(this.timerFlag)
          this.timeFlag = null
        }
        this.timerFlag = setInterval(async () => {
          await this.getWaitingForTakeReportData(params)
        }, 30000)
        await this.getWaitingForTakeReportData(params)
      } else if (this.defaultListKey === '3') {
        await this.getMyProcessingReportData(params)
      } else if (this.defaultListKey === '4') {
        await this.getMyFinishedReportData(params)
      } else if (this.defaultListKey === '5') {
        params.reportListTypeEnum = 'HISTORY'
        await this.getHisReportList(params)
      } else if (this.defaultListKey === '6') {
        params.reportListTypeEnum = 'ALL'
        await this.getAllList(params)
      }
    },
    // 设置当前url
    setCurrentUrl (params) {
      let currentUrl = window.location.protocol + '//' + window.location.host + this.$route.path + `?`
      for (let k in params) currentUrl = `${currentUrl}&${k}=${params[k]}`
      currentUrl = currentUrl.replace(/\&/, '')
      window.history.replaceState(null, null, currentUrl)
    },
    // 获取当前报告数据
    async getReportInfo () {
      let query = { id: this.activeId }
      if (+this.defaultListKey === 2) query.fetchHistoryReport = 1
      let data = await getReportPatientInfo(query)
      if (data) {
        this.reportInfo = data
      }
    },
    // 分页
    async pageData (data) {
      if (this.timerFlag) {
        clearInterval(this.timerFlag)
        this.timeFlag = null
      }
      this.pageNo = data.pageNo
      if (this.defaultListKey == '2') {
        this.waitingList = []
      }
      this.setCurrentUrl({curKey: this.defaultListKey, pageNo: this.pageNo})
      await this.curKeyGetList()
    },
    // 认领审核报告检查
    async receiveAuditCheck (id) {
      let data = await receiveCheck({ patientId: id })
      return data
    },
    // 领取审核报告
    async sureReceiveReport () {
      this.loading.sureAudit = true
      let data = await receiveReport({ reportId: this.selectItem.id })
      if (data && (this.selectItem.report_category === 5 || this.selectItem.report_category === 15 || this.selectItem.report_category === 10)) {
        this.notAutomationToAudit()
      } else if (data) {
        this.loading.sureAudit = false
        this.auditReport.showModal = false
        toast({ title: '提示', msg: `领取患者${this.selectItem.patient_name || ''}报告成功！`, type: 'success' })
        this.$router.push({path: '/ris/edit', query: {reportId: this.selectItem.id}})
      }
    },
    // 获取统计数据
    async staticGetData (type) {
      let params = {
        pageNumber: this.pageNo,
        pageSize: this.pageSize,
        reportListTypeEnum: type
      }
      Object.assign(params, this.searchConditions())
      let data = await getStaticData(params)
      if (data) {
        this.staticData = data
      }
    },
    // 查看审核不通过原因
    async viewAuditNoPass () {
      let data = await viewAuditNotPassWhy({ id: this.selectItem.id })
      return data
    },
    // 召回报告
    async goBackReport () {
      let isReview = this.afterProcessData.report_write_doctor_id === this.afterProcessData.report_review_doctor_id
      if (+this.defaultListKey === 6) {
        if ((this.role.review || this.role.afterReview) && this.afterProcessData.review_required && !isReview) {
          this.recall.targetAddress = '审核中'
        } else {
          this.recall.targetAddress = '编写中'
        }
      } else {
        if ((this.role.review || this.role.afterReview) && this.afterProcessData.review_required) {
          this.recall.targetAddress = '审核中'
        } else {
          this.recall.targetAddress = '编写中'
        }
      }
      this.recall.openFlag = true
    },
    // 确认召回
    async recallAction () {
      try {
        this.loading.recallAction = true
        let params = {id: this.afterProcessData.id}
        let isReview = this.afterProcessData.report_write_doctor_id === this.afterProcessData.report_review_doctor_id
        if (+this.defaultListKey === 6) {
          if ((this.role.write || this.role.afterWrite) && !this.afterProcessData.review_required && isReview) params.targetAddress = 'reportWrite'
          if ([5, 15].includes(this.afterProcessData.report_category) && (this.role.write || this.role.afterWrite) && this.afterProcessData.review_required && isReview) params.targetAddress = 'reportWrite'
          if ((this.role.review || this.role.afterReview) && this.afterProcessData.review_required && !isReview) params.targetAddress = 'reportReview'
        } else {
          if ((this.role.write || this.role.afterWrite) && !this.afterProcessData.review_required) params.targetAddress = 'reportWrite'
          if ([5, 15].includes(this.afterProcessData.report_category) && (this.role.write || this.role.afterWrite) && this.afterProcessData.review_required) params.targetAddress = 'reportWrite'
          if ((this.role.review || this.role.afterReview) && this.afterProcessData.review_required) params.targetAddress = 'reportReview'
        }
        let  data = await recall(params)
        if (!data) throw Error('确认召回错误')
        toast({msg: '召回成功', title: '成功提示', type: 'success'})
        this.closeAllModal()
        await this.curKeyGetList()
      } catch (error) {
        console.log(error)
      } finally {
        this.loading.recallAction = false
      }
    },
    // 取消召回
    recallCancel () {
      this.recall.openFlag = false
    },
    // 根据角色判断报告操作按钮的显示
    roleIsShowBtn () {
      let roles = getSession('userAuth', 'object').roles || []
      for (let i = 0; i < roles.length; i++) {
        let val =  roles[i]
        this.roles.push(val.rcode)
      }
    },
    // 当前医生角色
    getDoctorRoles () {
      let auth = { write: false, review: false, afterReview: false, afterWrite: false }
      let role = getSession('userAuth', 'object') || null
      let userInfo = getSession('risUserInfo', 'object') || null
      if (!role || !role.roles || role.roles.length < 1) return auth
      auth.loginUserId = userInfo.id
      for (let i = 0; i < role.roles.length; i++) {
        let item = role.roles[i]
        if (item.rcode === 'ROLE_SENIOR_DOCTOR') {
          auth.review = true
          auth.write = true
        }
        if (item.rcode === 'ROLE_AUDIT_REPORT') {
          auth.review = true
          auth.afterReview = true
        }
        if (item.rcode === 'ROLE_WRITE_REPORT') auth.write = true
        if (item.rcode === 'ROLE_AFTER_DEAL_REPORT') {
          auth.afterWrite = true
        }
      }
      return auth
    },
    // 获取上传报告列表
    async upLoadList () {
      let data = await getUploadList({ id: this.afterProcessData.id || this.selectItem.id })
      if (data && data.reportFiles && data.reportFiles.length > 0) this.imageList = data.reportFiles
      else this.imageList = []
    },
    // 放弃
    async giveUp () {
      if (this.afterProcessData.status === 30) {
        this.giveUpModal.type = '审核'
        let data = await getMyWritingTask({ id: this.afterProcessData.id, status: 'IN_AUDIT' })
        if (data && data.length > 1) {
          this.giveUpModal.tableData = data
          this.giveUpModal.multiple = true
        }
      }
      if (this.afterProcessData.status === 10) {
        this.giveUpModal.type = '编写'
        let data = await getMyWritingTask({ id: this.afterProcessData.id, status: 'WRITING'})
        if (data && data.length > 1) {
          this.giveUpModal.tableData = data
          this.giveUpModal.multiple = true
        }
      }
      this.giveUpModal.openFlag = true
    },
    // 放弃全部
    async giveUpAll () {
      try {
        this.loading.giveUpAll = true
        // 审核放弃
        if (this.afterProcessData.status === 20 || this.afterProcessData.status === 30) {
          let reportIdList = []
          this.giveUpModal.tableData.forEach(val => {
            reportIdList.push(val.id)
          })
          await this.sureGiveUpAuditReport(reportIdList)
        }
        // 编写放弃
        if (this.afterProcessData.status === 10 || this.afterProcessData.status === 1) {
          if (await giveUpAllWriting({id: this.afterProcessData.id, status: 'WRITING'})) toast({msg: '放弃全部报告成功', title: '成功提示', type: 'success'})
        }
        this.closeAllModal()
      } catch (error) {
        console.log('放弃全部错误')
      } finally {
        this.loading.giveUpAll = false
      }
    },
    // 放弃当前报告
    async giveUpCurrent () {
      try {
        this.loading.giveUpCurrent = true
        // 审核放弃
        if (this.afterProcessData.status === 20 || this.afterProcessData.status === 30) {
          this.selectItem.status = 20
          await this.sureGiveUpAuditReport([this.afterProcessData.id])
        }
        // 编写放弃
        if (this.afterProcessData.status === 10 || this.afterProcessData.status === 1) {
          this.selectItem.status = 1
          if (await giveUpWriting({id: this.afterProcessData.id, status: 'WRITING'})) toast({msg: '放弃当前报告成功', title: '成功提示', type: 'success'})
        }
        await this.curKeyGetList()
        this.closeAllModal()
      } catch (error) {
        console.log('放弃当前报告错误')
      } finally {
        this.loading.giveUpCurrent = false
      }
    },
    // 确定放弃审核报告
    async sureGiveUpAuditReport (idList) {
      let params = idList.join(',')
      let data = await giveUpReport({ reportIdList: params })
      if (data) {
        this.selectItem.status = 20
        toast({ title: '提示', msg: '审核报告放弃成功！', type: 'success' })
      }
      await this.curKeyGetList()
      this.closeAllModal()
    },
    // 取消放弃
    cancelGiveUp () {
      this.giveUpModal.openFlag = false
    },
    // 根据医生角色展示tab页
    getRoleTabs () {
      setSession('browerReportList', true)
      if (this.roles.includes('ROLE_ROOT') || this.roles.includes('ROLE_AFTER_DEAL_REPORT'))  return this.defaultListKey = '2'
      if (this.roles.includes('ROLE_WRITE_REPORT') || this.roles.includes('ROLE_AUDIT_REPORT')) return this.defaultListKey = '2'
      if (this.roles.includes('ROLE_SENIOR_DOCTOR')) return this.defaultListKey = '6'
    },
    // 判断用户是否为自己
    isMyself (user) {
      let me = getSession('risUserInfo', 'object')
      if (me.id === user) return true
      else return false
    },
    // 历史报告
    historyReport () {
      if (!this.selectItem.id) toast({ title: '提示', msg: '请选中您要操作的报告！', type: 'warning' })
      return openNewWindow(`/ris/reportHistory?reportId=${this.selectItem.id}`)
    },
    // 查看后处理报告
    async viewsAfterReport () {
      if (!this.selectItem.id) toast({ title: '提示', msg: '请选中列表中其中一个报告！', type: 'warning' })
      if (this.isControl('view')) {
        let data = await getReportPatientInfo({ id: this.activeId })
        if (data && data.reportInfo) {
          this.afterProcessData = data.reportInfo
          this.afterReport.showModal = true
          this.afterReport.multiple = false
          this.afterReport.showHandler = true
          this.afterReport.showFooter = null
          this.afterReport.title = 'AI算法'
          await this.upLoadList()
        }
      }
    },
    // 关闭所有弹框
    closeAllModal () {
      this.receiveReport.showModal = false
      this.afterReport.showModal = false
      this.auditReport.showModal = false
      this.showCommitAudit = false
      this.showNotPassAudit = false
      this.showAuditPass = false
      this.showRecalculate = false
      this.showRemoveReport = false
      this.recall.openFlag = false
      this.giveUpModal.openFlag = false
    },
    async showAppoointmentList() {
      this.appointment.hospitalId = this.searchOption.checkHospitalList[0]['hospital_id']
      this.appointment.showModal = true
      await this.getAppointmentList()
    },
    async getAppointmentList() {
      let params = {
        hospitalId: this.appointment.hospitalId,
        date: this.appointment.date.format('YYYY-MM-DD')
      }
      let data = await getNewSystemList(params)
      if (!data) return false
      this.appointment.list = data
    },
    async changeAppointmentDate(date) {
      this.appointment.date = date
      await this.getAppointmentList()
    },
    writeAiReport() {
      let timer = setTimeout(() => {
        this.writeAiReportFlag = true
        clearTimeout(timer)
      }, 100)
    },
    async submitAiReportParams() {
      this.uploadAiReportLoading = true
      let data = await this.$refs.AiReportForm.submitParams()
      this.uploadAiReportLoading = false
      if (data) {
        toast({msg: '保存成功', type: 'success', title: '操作提示'})
        await this.getReportInfo()
        this.writeAiReportFlag = false
      } else return false
    }
  }
}
</script>

<style lang="less">
@import url('../../style/index.less');
.editReportListPage{
  height: 100%;
  width: 100%;
  overflow: hidden;
  .mainContent{
    height: 100%;
    width: 100%;
    display:flex;
    .leftContentWrap{
      flex: 1;
      margin-top: @LeaveDistance;
      padding: 0 16px !important;
      min-height: 100vh;
      overflow: hidden;
      .cateTabs{
        background-color: #fff;
        .ant-tabs-bar{
          margin: 0 0 16px 16px;
        }
        .arowWrap{
          width: 100px;
          display: inline-block;
        }
      }
    }
  }
  .rightContent{
    min-width: 252px;
    max-width: 252px;
    height: 100%;
    overflow-y: auto;
    margin: @LeaveDistance @LeaveDistance 0 0;
    background-color: @baseColor;
    .static{
      height: 45px;
      padding: 0 @LeaveDistance;
      line-height: 45px;
      border-bottom: 1px solid @divideLineColor;
      .ant-card-body{
        padding: 0;
      }
    }
    .operateCard{
      border: none;
      border-bottom: none;
      .ant-card-body{
        padding: 0;
      }
      .top{
        padding: @LeaveDistance;
        button{
          height: 56px;
          font-size: 16px;
        }
      }
      .bottom{
        padding-left: @LeaveDistance;
        margin: 0 0 @LeaveDistance 0;
        button{
          width: 100px;
          height: 56px;
          margin-right: @LeaveDistance;
        }
        .clearBtnFocus();
      }
    }
    .checkPatient{
      .ant-card-body{
        padding: 0;
      }
      .history{
        margin-left: @LeaveDistance;
      }
      .reportMsg{
        max-width: 252px;
        padding: @LeaveDistance 0 @LeaveDistance @LeaveDistance;
        border-top: 1px solid @divideLineColor;
        p{
          margin-bottom: @LeaveDistance;
        }
      }
    }
  }
  .watchAppointmentList{
    position: fixed;
    right: 50px;
    bottom: 100px;
    .ant-btn{
      width: 70px;
      height: 70px;
      padding: 0;
      line-height: 70px;
      border-radius: 50%;
      box-shadow: 1px 1px 1px 1px rgba(204, 197, 197, 0.5);
    }
  }
}
.editReportListPageModal{
  .image{
    min-height: 300px;
    max-height: 300px;
    margin: 10px 0;
    padding: 10px;
    background: @divideLineColor;
    overflow: auto;
    p{
      border-bottom: 1px solid #333;
      line-height: 20px;
      height: 30px;
      span{
        float: right;
        a{
          margin: 0 5px;
          text-decoration: underline;
        }
      }
    }
  }
}
.appointmentListModal{
  .ant-modal-body{
    max-height: auto;
    overflow: hidden;
  }
}
.aiEditReportModal{
  .ant-modal-body{
    max-height: 800px;
    overflow: auto;
  }
}
</style>